<template>
  <div class="table" style="padding: 10px">
    <a-row type="flex" align="middle" justify="space-between" style="margin-bottom: 10px" v-if="layout.layoutType">
      <h4>
        <a-space>
          配方原料
          <!-- <a-button type='link' size="small" @click="toggleRawVisible" style="font-size:12px">批量添加</a-button> -->
        </a-space>
      </h4>
      <a-space class="icon-bar">
        <a-button type="link" @click="toggleRawVisible">
          <img :src="addImg" alt="添加原料" />
        </a-button>
        <a-tooltip>
          <template slot="title">移出原料</template>
          <a-badge :count="rawRows.length">
            <!-- <a-button icon="delete" type="link" :disabled="rawRows.length == 0" @click="removeRaw" /> -->
            <a-button type="link" :disabled="rawRows.length === 0" @click="removeRaw">
              <img :src="deleteImg" alt="移出原料" />
            </a-button>
          </a-badge>
        </a-tooltip>
        <slot />
      </a-space>
    </a-row>
    <a-row class="list-block" v-if="layout.layoutType">
      <!-- <a-col class="list-block-side" :span="leftSpan" :style="{height:`${height}px`}"  v-if="layout.showSider" >
        <raw-side ref="allRawList" @ok="addSignleRaw"/>
      </a-col> -->
      <!-- <a-col :span="rightSpan"> -->
      <a-col>
        <resize-table :scroll="{
          x: tableWidth,
          y: detail.referPriceSource ? height - 45 : height,
        }" bordered :columns="rawColumnsValue" :loading="rawListLoading" tableName="rawTableColumns"
          :data-source="list.records" :row-selection="{
            selectedRowKeys,
            onSelect,
            getCheckboxProps,
            onSelectAll,
          }" :row-key="(record) => record.id" :pagination="false" :rowClassName="rowClassname">
          <span slot="customTitle"><a-icon @click="fixedCol" type="pushpin" :theme="filled ? 'filled' : 'outlined'" />
            原料名称</span>
          <template slot="ptcArrowFlag" slot-scope="text, record">
            <img v-if="record.ptcArrowFlag === '1'" :src="arrowUpImg" alt="上涨" class="arrow-icon up" />
            <img v-else-if="record.ptcArrowFlag === '2'" :src="arrowDownImg" alt="下跌" class="arrow-icon down" />
            <span v-else></span>
          </template>
          <div slot="rawName" slot-scope="text, item" style="display: flex;">
            <!-- 失效图标 -->
            <template v-if="item.status === 1">
              <img style="width: 26px; position: absolute; top: 0; left: 0"
                src="../../../../assets/images/shixiao.svg" />
              <div style="width: 6px"></div>
            </template>
            <!-- 次要原料图标（组合包小料）- 失效时不显示 -->
            <template v-else-if="item.isRawMinor === '1' && detail.isStartBag === 1">
              <img style="width: 26px; position: absolute; top: 0; left: 0px"
                src="../../../../assets/images/raw_bag_zhb.svg" />
              <div style="width: 6px"></div>
            </template>
            <a-tooltip size="small">
              <!-- <span v-if="!item.storageWeight" class="storageTips"><a-icon type="tags" /></span> -->
              <a-row v-if="item.isRawDelete == 1" type="flex" align="middle" justify="space-between">
                <span style="padding: 2px 4px; flex: 1" class="nameStyle"
                  :class="{ 'turnoverday-tip': turnoverDayTip(item) }">
                  {{ overseasFlag == "1" ? item.aliasName || text : text }}
                </span>
                <a-button v-if="item.isExtraProRaw != '1'" type="link" size="small" icon="delete"
                  @click="viewRaw(item)" />
              </a-row>

              <a-row v-if="item.isRawDelete != 1 && item.isExtraProRaw == '1'" type="flex" align="middle"
                justify="space-between">
                <span style="padding: 2px 4px; flex: 1" class="nameStyle"
                  :class="{ 'turnoverday-tip': turnoverDayTip(item) }">
                  {{ overseasFlag == "1" ? item.aliasName || text : text }}
                </span>
                <a-button type="link" size="small" icon="plus" @click="viewRaw(item)" />
              </a-row>

              <a v-if="item.isExtraProRaw != '1' && item.isRawDelete != 1" @click="viewRaw(item)" class="nameStyle"
                :class="{ 'turnoverday-tip': turnoverDayTip(item) }">
                {{ overseasFlag == "1" ? item.aliasName || text : text }}
              </a>

              <template slot="title">
                {{ overseasFlag == "1" ? item.aliasName || text : text }}
                <span v-if="item.storageWeight || item.storageWeight === 0">
                  ，库存【{{ Number(item.storageWeight).toFixed(3) }}{{ item.unit }}】
                </span>
                <span v-if="item.turnoverDay || item.turnoverDay === 0">
                  ，可耗用天数【{{ item.turnoverDay }}天】
                </span>
              </template>
            </a-tooltip>
            <!-- 可耗用库存提示 -->
            <!-- <a-tooltip v-if="turnoverDayTip(item)" style="margin-right: 10px;" :overlayStyle="{ maxWidth: 'auto' }">
              <template slot="title">
                高库存原料（>{{ (item.purchaseClassCode === '1001' ? '15' : '30') }}天）：可耗用天数【{{ item.turnoverDay }}天】
              </template>
              <img style="width: 14px;height: 14px;position: relative;top: 2px;left: 4px;"
                src="../../../../assets/images/storageTip.png" />
            </a-tooltip> -->
          </div>
          <template slot="turnoverDay" slot-scope="text">
            <span>{{ text || text === 0 ? text.toFixed(2) : "" }}</span>
          </template>
          <template slot="productRawPercentage" slot-scope="text, record">
            {{
            text
            | numberFixed(
            record.unit === "MJ" || record.unit === "Kcal" ? 0 : 3
            )
            }}
          </template>
          <template v-for="(col, i) in ['price', 'minValue', 'maxValue']" slot-scope="text, record" :slot="col">
            <span v-if="record.isRawDelete == 1 || record.isExtraProRaw == 1" :key="col">
              {{ text | numberFixed(3) }}
            </span>
            <cell-editor v-else :background="true" :key="i" :item="record" :len="3" :name="col"
              @blur="(target) => itemUpdate(target, record.id, record, col)" :text="text" :actions="update" />
          </template>
          <template slot="footer">
            <a-alert v-if="this.alertFlag && this.selectedRows.length > 0" type="info" show-icon closable
                     @close="cancelOnly"  style="margin-top: 0;">
              <template #message>
                <a-row type="flex" justify="space-between">
                  <a-col>
                <span>
                  选中<span style="color: green">{{ selectedRows.length }}</span>个原料，
                  <span class="alert-info">
                    成本合计<span style="color: green">{{ totalCost.toFixed(3) }}</span>(元/吨)，
                    用量(%)合计<span style="color: green">{{ totalPercentage.toFixed(3) }}%</span>。
                  </span>
                </span>
                  </a-col>
                  <a-col>
                    <a @click="cancelSelection" style="margin-right: 20px;">取消选中</a>
                  </a-col>
                </a-row>
              </template>
            </a-alert>
          </template>
          <span v-for="item in [
            'storageWeight',
            'percentage',
            'maxApply',
            'minApply',
            'uasge',
            'maxShadowPrice',
            'minShadowPrice',
            'cost',
            'minLimitValue',
            'maxLimitValue',
          ]" :slot="item" slot-scope="text" :key="item">
            <span :key="item" v-if="item === 'cost'">{{ text ? text.toFixed(3) : "" }}</span>
            <span v-else>{{ text || text === 0 ? text.toFixed(3) : "" }}</span>
          </span>
        </resize-table>
      </a-col>
    </a-row>

    <resize-table v-else :scroll="{
      x: tableWidth,
      y: detail.referPriceSource ? height - 35 : height + 10,
    }" bordered tableName="rawTableColumns" :columns="rawColumnsValue" :loading="rawListLoading"
      :data-source="list.records" :row-selection="{
        selectedRowKeys,
        onSelect,
        getCheckboxProps,
        onSelectAll,
      }" :row-key="(record) => record.id" :pagination="false" :rowClassName="rowClassname">

      <div slot="customTitle" style="display:flex">
        <a-icon @click="fixedCol" type="pushpin" :theme="filled ? 'filled' : 'outlined'" />
        原料名称
      </div>
      <template slot="ptcArrowFlag" slot-scope="text, record">
        <img v-if="record.ptcArrowFlag === '1'" :src="arrowUpImg" alt="上涨" class="arrow-icon up" />
        <img v-else-if="record.ptcArrowFlag === '2'" :src="arrowDownImg" alt="下跌" class="arrow-icon down" />
        <span v-else></span>
      </template>

      <div slot="rawName" slot-scope="text, item" style="display: flex;">
        <!-- 失效图标 -->
        <template v-if="item.status === 1">
          <img style="width: 26px; position: absolute; top: 0; left: 0" src="../../../../assets/images/shixiao.svg" />
          <div style="width: 6px"></div>
        </template>
        <!-- 次要原料图标（组合包小料）- 失效时不显示 -->
        <template v-else-if="item.isRawMinor === '1' && detail.isStartBag === 1">
          <img style="width: 26px; position: absolute; top: 0; left: 0px"  src="../../../../assets/images/raw_bag_zhb.svg" />
          <div style="width: 6px"></div>
        </template>
        <a-tooltip size="small">
          <a-row v-if="item.isRawDelete == 1" type="flex" align="middle" justify="space-between">
            <span style="padding: 2px 4px; flex: 1" class="nameStyle"
              :class="{ 'turnoverday-tip': turnoverDayTip(item) }">
              {{ overseasFlag == "1" ? item.aliasName || text : text }}
            </span>
            <a-button v-if="item.isExtraProRaw != '1'" type="link" size="small" icon="delete" @click="viewRaw(item)" />
          </a-row>

          <a-row v-if="item.isRawDelete != 1 && item.isExtraProRaw == '1'" type="flex" align="middle"
            justify="space-between">
            <span style="padding: 2px 4px; flex: 1" class="nameStyle"
              :class="{ 'turnoverday-tip': turnoverDayTip(item) }">
              {{ overseasFlag == "1" ? item.aliasName || text : text }}
            </span>
            <a-button type="link" size="small" icon="plus" @click="viewRaw(item)" />
          </a-row>

          <a v-if="item.isExtraProRaw != '1' && item.isRawDelete != 1" @click="viewRaw(item)" class="nameStyle"
            :class="{ 'turnoverday-tip': turnoverDayTip(item) }">
            {{ overseasFlag == "1" ? item.aliasName || text : text }}
          </a>

          <template slot="title">
            {{ overseasFlag == "1" ? item.aliasName || text : text }}
            <span v-if="item.storageWeight || item.storageWeight === 0">
              ，库存【{{ Number(item.storageWeight).toFixed(3) }}{{ item.unit }}】
            </span>
            <span v-if="item.turnoverDay || item.turnoverDay === 0">
              ，可耗用天数【{{ item.turnoverDay }}天】
            </span>
          </template>
        </a-tooltip>
        <!-- 可耗用库存提示 -->
        <!-- <a-tooltip v-if="turnoverDayTip(item)" style="margin-right: 10px;" :overlayStyle="{ maxWidth: 'auto' }">
          <template slot="title">
            高库存原料（>{{ (item.purchaseClassCode === '1001' ? '15' : '30') }}天）：可耗用天数【{{ item.turnoverDay }}天】
          </template>
          <img style="width: 14px;height: 14px;position: relative;top: 2px;left: 4px;"
            src="../../../../assets/images/storageTip.png" />
        </a-tooltip> -->
      </div>
      <template slot="turnoverDay" slot-scope="text">
        <span>{{ text || text === 0 ? text.toFixed(2) : "" }}</span>
      </template>
      <template slot="productRawPercentage" slot-scope="text, record">
        {{
        text
        | numberFixed(
        record.unit === "MJ" || record.unit === "Kcal" ? 0 : 3
        )
        }}
      </template>
      <template v-for="(col, i) in ['price', 'minValue', 'maxValue']" slot-scope="text, record" :slot="col">
        <span v-if="record.isRawDelete == 1 || record.isExtraProRaw == 1" :key="col">
          {{ text ? text.toFixed(3) : "" }}
        </span>
        <cell-editor v-else :background="true" :key="i" :item="record" :len="3" :name="col" @click="saveRow(record)"
          @blur="(target) => itemUpdate(target, record.id, record, col)" :text="text" :actions="update" />
      </template>
      <template slot="footer">
        <a-alert v-if="this.alertFlag && this.selectedRows.length > 0" type="info" show-icon closable
                 @close="cancelOnly" class="inline-alert">
          <template #message>
            <a-row type="flex" justify="space-between">
              <a-col>
                <span>
                  选中<span style="color: green">{{ selectedRows.length }}</span>个原料，
                  <span class="alert-info">
                    成本合计<span style="color: green">{{ totalCost.toFixed(3) }}</span>(元/吨)，
                    用量(%)合计<span style="color: green">{{ totalPercentage.toFixed(3) }}%</span>。
                  </span>
                </span>
              </a-col>
              <a-col>
                <a @click="cancelSelection" style="margin-right: 20px;">取消选中</a>
              </a-col>
            </a-row>
          </template>
        </a-alert>
      </template>
      <span v-for="item in [
        'storageWeight',
        'percentage',
        'maxApply',
        'minApply',
        'uasge',
        'maxShadowPrice',
        'minShadowPrice',
        'cost',
        'minLimitValue',
        'maxLimitValue',
      ]" :slot="item" slot-scope="text" :key="item">
        <span v-if="item === 'cost'">{{ text ? text.toFixed(3) : "" }}</span>
        <span v-else>{{ text || text === 0 ? text.toFixed(3) : "" }}</span>
      </span>
    </resize-table>
    <raw-model :hidden="rawVisible" @cancel="toggleRawVisible" @ok="addRaw" />
    <nutrient-modal ref="nutrientModel" @refresh="refresh" @refreshNutrition="refreshNutrition" />
    <calculation-result-modal @ok="confirmResult" />
  </div>
</template>

<script>
// 用量（%）= 最大值和极上限时，最大值、极上限显示为红色；用量（%）= 最小值和极下限时，最小值、极下限显示为绿色
import { nhfMixins } from '../../untils';
import CalculationResultModal from '../modal/CalculationResultModal.vue';
import NutrientModal from '../modal/NutrientModal.vue';
import RawModel from '../modal/RawModel.vue';
import CellEditor from './CellEditor.vue';
import deleteImg from '@/assets/images/icon/delete.png';
import addImg from '@/assets/images/icon/add.png';
import arrowUpImg from '@/assets/images/arrow-up.svg';
import arrowDownImg from '@/assets/images/arrow-down.svg';

export default {
  mixins: [nhfMixins],
  components: {
    RawModel,
    CellEditor,
    // RawSide,
    CalculationResultModal,
    NutrientModal,
  },
  data() {
    return {
      tableWidth: 1200,
      deleteImg, addImg, // icon
      filled: true,
      itemVisible: false,
      rawVisible: false,
      rawListLoading: false,
      filterData: {},
      currentValue: null,
      priceValues: '',
      list: {
        records: []
      },
      cacheData: [],
      // 原料名称、代码、价格、用量%、最小值、最大值、用量(批次量)、影子价格下限、影子价格上限、单位成本、适用下限、适用上限、极下限、极上限；
      priceVal: ['privateContractPrice', 'privatePredictionPrice', 'privateStockPrice', 'privateMarketPrice'],
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      rowData: {},
      arrowUpImg,
      arrowDownImg,
    };
  },
  mounted() {
    const { id } = this.$route.query;
    this.formulaId = id;

    const viewportWidth = window.innerWidth;
    const _width = viewportWidth;
    const layoutType = window.localStorage.getItem('layoutType');
    if (layoutType==='layoutType') {
      this.tableWidth = _width * 0.6 - 60;
    } else {
      this.tableWidth = _width - 70;
    }
  },
  props: ['showAdd'],
  computed: {
    leftSpan() {
      const { showSider } = this.layout;
      return showSider ? 4 : 24;
    },
    rightSpan() {
      const { showSider } = this.layout;
      return showSider ? 20 : 24;
    },
    removeDisable() {
      return this.selectedRowKeys.length === 0;
    },
    priceValue() {
      let pr = this.priceOption[this.detail.priceSource - 1];
      return pr ? pr.label : null;
    },
    listData() {
      // let rawIds = this.selectedRowKeys.map(item => {
      //   return this.selectedRows.filter(i=>i.id === item)[0].rawId
      // })
      return {
        // rawIds:this.selectedRows.map(item => item.id).join(),
        ids: this.rawRows.map(i => i.id).join(),
        rawIds: this.rawRows.map(i => i.rawId).join(),
        formulaId: this.formulaId
      };
    },
  },

  watch: {
    selectedRows: {
      handler(rawRows) {
        this.$emit('select', rawRows);
        if (rawRows[0]) {
          this.setState({ rawSelect: rawRows[0], rawRows });
        } else {
          this.setState({ rawSelect: {}, rawRows: [] });
        }
      },
      deep: true
    },
    async rawTypeSelect() {
      this.filterList();
    }
  },

  methods: {
    refreshNutrition() {
      this.$emit('refreshNutrition');
    },
    saveRow(record) {
      this.rowData = { ...record };
    },
    changeColumns2() {
      let rawColumnsValue = [...this.rawColumnsValue];
      const pin = (key, on) => {
        const idx = rawColumnsValue.findIndex(col => col.dataIndex === key);
        if (idx > -1) {
          if (on) {
            rawColumnsValue[idx].fixed = 'left';
          } else {
            delete rawColumnsValue[idx].fixed;
          }
        }
      };
      pin('ptcArrowFlag', this.filled);
      pin('rawName', this.filled);
      this.setState({ rawColumnsValue });
    },
    fixedCol(e) {
      this.filled = !this.filled;
      this.changeColumns2();
      e = e || window.event;
      if (e.stopPropagation) { //W3C阻止冒泡方法
        e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    getCheckboxProps(record) {
      return ({
        props: {
          disabled: (record.isRawDelete == 1 || record.isExtraProRaw == 1) || (!this.selectedRowKeys.includes(record.id) && this.selectedRowKeys.length > this.maxLen),
        }
      });
    },

    confirmResult(changeList, otherList) {
      this.$refs['nutrientModel'].setResult(changeList, otherList);
    },

    getResult(rawResult) {
      this.rawResult = rawResult;
      this.toggleResultVisible();
    },

    viewRaw(rawSelect) {
      if (rawSelect.isRawDelete == 1) {
        // this.$message.warn('原料已经删除')
        this.removeRaw(rawSelect);
      } else {
        if (rawSelect.isExtraProRaw == 1) {
          this.addRaw([rawSelect], true);
          this.$emit('refresh', false, false);
        } else {
          this.setState({ rawSelect });
          this.toggleVisible('raw');
        }
      }
    },
    refresh() {
      this.$emit('refresh', false, false);
    },

    rowClassname(record) {
      return record.isRawDelete == 1 || record.isExtraProRaw == 1 ? 'selectGary' : (record.percentage === 0 ? 'selectRows' : '');
    },

    cleanSelect() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },

    addSignleRaw() {
      this.getList();
    },

    async addRaw(row, isSider) {
      this.rawListLoading = true;
      isSider || this.toggleRawVisible();
      await this.fetchPost({
        actions: this.saveFormulaRawIds,
        loading: 'addLoading',
        data: {
          rawIds: row.map(i => i.rawId).join(), // item.rawId,
          formulaId: this.$route.query.id,
          factoryId: this.factoryId
        }
      });
      this.getList();
    },

    toggleRawVisible() {
      this.rawVisible = !this.rawVisible;
    },

    itemChange(value, id, column) {
      const newData = [...this.list.records];
      const target = newData.filter(item => id === item.id)[0];
      if (target) {
        target[column] = value;
        this.list.records = newData;
      }
    },

    eidtorItem(id) {
      const newData = [...this.list.records];
      const target = newData.filter(item => id === item.id)[0];
      this.editingKey = id;
      if (target) {
        target.editable = true;
        this.list.records = newData;
      }
    },

    itemUpdate(item, id) {
      const newData = [...this.list.records];
      const newCacheData = [...this.cacheData];
      const targets = newData.filter(item => id === item.id)[0];
      const targetCache = newCacheData.filter(item => id === item.id)[0];
      if (targets && targetCache) {
        Object.assign(targetCache, item);
        Object.assign(targets, item);
        this.cacheData = newCacheData;
        this.list.records = newData;
        this.calculatePrice();
      }
    },
    computerTotal(data){
      //计算selectedRows中percentage和price和
      this.totalCost = 0
      this.totalPercentage = 0
      if(this.selectedRows.length>0){
        this.selectedRows.forEach((item)=>{
          //如果item 和 data id 相等是同一条数据，将百分比较和价格覆盖
          if(item.rawId === data.rawId){
            item.percentage = data.percentage
            item.price = data.price
          }
          if(item.price && item.percentage){
            this.totalCost = this.totalCost + item.price * item.percentage
            this.totalPercentage = this.totalPercentage + item.percentage
          }
        })
        if(this.totalCost!==0) {
          this.totalCost = this.fixedNumber(this.totalCost / 100, 1000)
        }
        if(this.totalPercentage!==0) {
          this.totalPercentage = this.fixedNumber(this.totalPercentage, 1000)
        }
      }
    },
    async update(arg, type, name) {
      let datas = JSON.parse(JSON.stringify(arg));
      delete datas.rawName;
      const { price, rawId } = datas;
      const isPrice = name == 'price';
      const cacheData = datas;
      const data = isPrice ? { price, priceSource: this.detail.priceSource, rawId, factoryId: this.factoryId } : datas;
      const response  = await this.fetchPost({
        actions: isPrice ? this.updateFactoryStaffRawPrice : this.formularawUpdate,
        data,
        showMessage: false
      });
      if(response.code === 200){
        await this.fetchPost({
          actions: this.formularawUpdateCache,
          data: cacheData,
          showMessage: false
        });
        
        // 局部更新：如果后端返回了受影响的数据，则只更新这些行
        // 获取 list 数据，支持多种响应格式
        let affectedList = null;
        
        // 1. 尝试从 response.records 获取（类似 getList 的格式）
        if (response.records && Array.isArray(response.records)) {
          affectedList = response.records;
          console.log('从 response.records 获取到数据:', affectedList);
        }
        // 3. 尝试从 response 本身获取（如果 response 直接是数组）
        else if (Array.isArray(response)) {
          affectedList = response;
          console.log('response 本身就是数组:', affectedList);
        }
        
        // 如果获取到了数据，进行局部更新；否则全量刷新
        if (affectedList && affectedList.length > 0) {
          this.updateAffectedRows(affectedList);
        } else {
          console.log('未获取到受影响的数据，执行全量刷新');
          // await this.getList();
        }
      }
      this.$emit('refresh', false, false);
      this.computerTotal(datas);
      return {};
    },
    
    // 局部更新受影响的行数据
    updateAffectedRows(affectedData) {
      if(!affectedData || affectedData.length === 0) return;
      
      // 定义允许更新的字段白名单（只更新这些字段，其他字段保持不变）
      const allowedFields = [
        'minValue',      // 最小值
        'maxValue',      // 最大值
        // 'price',         // 价格
        // 'percentage',    // 用量百分比
        // 'cost',          // 成本
        // 'storageWeight', // 库存
        // 'turnoverDay',   // 可耗用天数
        // 'uasge',         // 用量(批次量)
        // 'maxShadowPrice', // 影子价格上限
        // 'minShadowPrice', // 影子价格下限
        // 'minLimitValue',  // 适用下限
        // 'maxLimitValue',  // 适用上限
        // 'minApply',       // 极下限
        // 'maxApply',       // 极上限
        // 'productRawPercentage', // 产品原料百分比
        // 'referPrice',     // 参考价格
        // 'ptcArrowFlag',   // 价格趋势标识
      ];
      
      const newData = [...this.list.records];
      const newCacheData = [...this.cacheData];
      
      affectedData.forEach(updatedRow => {
        // 根据 id 或 rawId 查找并更新对应的行
        const recordIndex = newData.findIndex(item => 
          item.id === updatedRow.id || item.rawId === updatedRow.rawId
        );
        const cacheIndex = newCacheData.findIndex(item => 
          item.id === updatedRow.id || item.rawId === updatedRow.rawId
        );
        
        // 只提取允许更新的字段
        const filteredUpdate = {};
        allowedFields.forEach(field => {
          if (Object.prototype.hasOwnProperty.call(updatedRow, field)) {
            filteredUpdate[field] = updatedRow[field];
          }
        });
        
        if(recordIndex > -1 && Object.keys(filteredUpdate).length > 0) {
          // 只更新白名单中的字段
          newData[recordIndex] = { ...newData[recordIndex], ...filteredUpdate };
          console.log(`更新行 id=${newData[recordIndex].id}, 更新字段:`, Object.keys(filteredUpdate));
        }
        if(cacheIndex > -1 && Object.keys(filteredUpdate).length > 0) {
          newCacheData[cacheIndex] = { ...newCacheData[cacheIndex], ...filteredUpdate };
        }
      });
      
      this.list.records = newData;
      this.cacheData = newCacheData;
      this.calculatePrice();
      this.filterList();
    },

    async resetRaw() {
      if (this.selectedRows.length) {
        this.$confirm({
          title: '提示',
          content: '确认将选中的原料恢复至默认值吗？',
          okText: '继续',
          cancelText: '取消',
          onOk: async () => {
            await this.fetchPost({
              actions: this.resetFormulaRawIds,
              data: this.listData
            });
            this.getList();
          },
          onCancel() { },
        });
      } else {
        this.$message.warn('请选择需要更新的原料');
      }
    },

    async removeRaw(item) {
      this.$confirm({
        title: '提示',
        content: '确认将选中的原料移出？',
        okText: '继续',
        cancelText: '取消',
        onOk: async () => this.removeRawAction(item),
        onCancel() { },
      });
    },

    async removeRawAction(item) {
      await this.fetchPost({
        actions: this.formulaManageRemove,
        data: item && item.id ? { formulaId: this.formulaId, ids: item.id, rawIds: item.rawId } : this.listData
      });
      this.$emit('refresh', false, false);
      this.getList();
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.$refs['allRawList'] && this.$refs['allRawList'].getList();
    },

    async getList(arg = {}) {
      this.list.records = [];
      // const res = await this.fetchGet({
      const res = await this.fetchPost({
        isList: true,
        loading: 'rawListLoading',
        name: 'list',
        actions: this.formulaRawNhfPage,
        showMessage: false,
        data: {
          formulaId: this.formulaId,
          factoryId: this.factoryId,
          ...arg,
          current: 1,
          size: 1000
        }
      });
      // if(res && res.data && res.data.records){
      if (res && res.records) {
        // res.records[res.records.length - 2].rawName = '测试长度过长的名称效果';
        this.cleanSelect();
        // this.cacheData = JSON.parse(JSON.stringify(res.data.records))
        this.cacheData = JSON.parse(JSON.stringify(res.records));
        this.calculatePrice();
      }
      this.filterList();
      // if(this.rawTypeSelect !== 'all'){
      //   const {data} = res
      //   if(data?.records){
      //     if(this.rawTypeSelect == 1)  this.list.records =  data.records.filter(i => i.percentage > 0)
      //     if(this.rawTypeSelect == 2)  this.list.records =  data.records.filter(i => i.percentage == 0)
      //   }
      // }
      return res;
    },
    calculatePrice() {
      let count = 0;
      let referCount = 0;
      this.cacheData.forEach(el => {
        count += (el.price || 0) * (el.percentage || 0) / 100;
        referCount += (el.referPrice || 0) * (el.percentage || 0) / 100;
      });
      this.$emit('countPrice', { val: count.toFixed(3), referVal: referCount.toFixed(3) });
    },
    filterList() {
      const list = JSON.parse(JSON.stringify(this.cacheData));
      if (list && list.length) {
        if (this.rawTypeSelect == 0) this.list.records = JSON.parse(JSON.stringify(this.cacheData));
        if (this.rawTypeSelect == 1) this.list.records = list.filter(i => i.percentage > 0);
        if (this.rawTypeSelect == 2) this.list.records = list.filter(i => i.percentage == 0);
      }
    },
    cancelOnly() {
      this.totalPercentage = 0;
      this.totalCost = 0;
      this.alertFlag = false;
    },
    cancelSelection() {
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.totalPercentage = 0;
      this.totalCost = 0;
      this.alertFlag = false;
    },
    turnoverDayTip(record) {
      //purchaseClassCode 1001: 大料，其余为小料
      if ((record.purchaseClassCode === '1001' && record.turnoverDay > 15)
        || (record.purchaseClassCode !== '1001' && record.turnoverDay > 30)) {
        return true;
      }
    },
  }

};
</script>

<style lang="scss" scoped>
::v-deep .ant-table.ant-table-bordered .ant-table-footer {
  padding: 0;
}
</style>
<style lang="scss">
.turnoverday-tip {
  color: #f87208;
}

.nameStyle {
  max-width: 140px;
}

.icon-bar ::v-deep .anticon {
  font-size: 16px !important;
}

.selectRows {
  background-color: rgba(255, 206, 163, 0.1) !important;
  background-color: #fff9e5 !important;
}

.selectGary {
  background-color: rgba(130, 130, 130, 0.1) !important;
}

h3 {
  margin: 0;
}

.red {
  color: red;
}

.green {
  color: green;
}

.bottom-modal {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 1000; // 确保弹窗在最上层
}

.arrow-icon {
  width: 14px;
  height: 14px;
  vertical-align: middle;

  &.up {
    filter: drop-shadow(0 0 0 red);
  }

  &.down {
    filter: drop-shadow(0 0 0 green);
  }
}
</style>

